


























import { Vue, Component } from "vue-property-decorator";
import quotesList from "@/plugins/quotes";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CFileManager from "@/components/fileManager/CFileManager.vue";
@Component({
  components: { CFileManager, CBlock }
})
export default class Error extends Vue {
  selectedQuote!: any;

  data() {
    return {
      selectedQuote: undefined
    };
  }

  generate() {
    this.selectedQuote = this.getRandom(0, this.quotes.length - 1);
  }

  getRandom(min: number, max: number) {
    let rand = min + Math.random() * (max + 1 - min);
    let floor = Math.floor(rand);
    return this.quotes[floor];
  }

  get quotes(): Array<any> {
    return quotesList;
  }

  created() {
    this.generate();
  }
}
